// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"descriptions--293qL","itemSingleline":"itemSingleline--1USDY","itemMultiline":"itemMultiline--102-_"};